import './App.css';
import SecretComponent from './SecretComponent';

function App() {
  return (
    <div>
      <SecretComponent />
    </div>
  );
}

export default App;
